/**
 * Canonical product taxonomy for HMA Quant Strategies.
 * Used by Strategies, Performance, Portfolio, Reports and Home.
 */

export const FAMILY_IDS = {
  ALL_WEATHER: 'all_weather',
  DIRECTIONAL: 'directional',
  MARKET_NEUTRAL: 'market_neutral',
  MOMENTUM: 'momentum',
  HIGH_OCTANE: 'high_octane',
  INTRADAY: 'intraday',
};

export const FAMILIES = [
  {
    id: FAMILY_IDS.ALL_WEATHER,
    slugs: ['tyr', 'hraesvelgr', 'heimdall', 'metis'],
    monthlyPrice: 44.99,
    annualPrice: 449.99,
  },
  {
    id: FAMILY_IDS.DIRECTIONAL,
    slugs: ['ares', 'ascalafo'],
    monthlyPrice: 59.99,
    annualPrice: 599.99,
  },
  {
    id: FAMILY_IDS.MARKET_NEUTRAL,
    slugs: ['janus'],
    monthlyPrice: 59.99,
    annualPrice: 599.99,
  },
  {
    id: FAMILY_IDS.MOMENTUM,
    slugs: ['bes'],
    monthlyPrice: 59.99,
    annualPrice: 599.99,
  },
  {
    id: FAMILY_IDS.HIGH_OCTANE,
    slugs: ['deimos', 'fobos'],
    monthlyPrice: 74.99,
    annualPrice: 749.99,
  },
  {
    id: FAMILY_IDS.INTRADAY,
    slugs: ['eos', 'artemis', 'helios', 'hyperion', 'horai', 'theia', 'astraeus', 'phaethon', 'hemera', 'selene', 'asteria', 'aether'],
    monthlyPrice: 59.99,
    annualPrice: 599.99,
  },
];

export const FAMILY_LABEL_KEY = (id) => `taxonomy.families.${id}`;

export function familyById(id) {
  return FAMILIES.find((f) => f.id === id) || null;
}

export function familyForSlug(slug) {
  return FAMILIES.find((f) => f.slugs.includes(slug)) || null;
}
